<button class="btn btn-primary m-0" (click)="showModal()" data-id-cypress="ci-data-filter">
  <mdb-icon fas icon="search" class="mr-1"></mdb-icon>
  Rechercher
</button>
<div class="d-block mt-3" *ngIf="options">
  <jhi-filter-button *ngFor="let optionButton of options" [attributeFilter]="optionButton" (buttonRemoved)="removeFilter(optionButton)"></jhi-filter-button>
</div>
